export { formatBytes, sourceLabel } from "@ccnote/shared";

/** 3800 hkd → "HK$38", 1250 usd → "US$12.50". */
export function formatMoney(amount: number, currency: string): string {
  const symbol = ({ hkd: "HK$", usd: "US$", cny: "¥" } as Record<string, string>)[currency.toLowerCase()] ?? `${currency.toUpperCase()} `;
  const value = amount / 100;
  return `${symbol}${Number.isInteger(value) ? value : value.toFixed(2)}`;
}

/** "365 days" → "1 year"; other lengths in days. */
export function formatDays(days: number): string {
  if (days % 365 === 0) return days === 365 ? "1 year" : `${days / 365} years`;
  if (days % 30 === 0) return days === 30 ? "1 month" : `${days / 30} months`;
  return `${days} days`;
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

/** Whole days from now until `iso` (negative once past). */
export function daysUntil(iso: string, now = Date.now()): number {
  return Math.ceil((Date.parse(iso) - now) / 86_400_000);
}
